"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Envelope = exports.Command = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Device = __importStar(require("../../../../../device"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Pubsub.Schema';
/*
 * `controllers/v2/pubsub/device/command.js` (protocol v1): the envelope the
 * Pub/Sub push subscription posts for a device command.
 */
exports.Command = effect_1.Schema.Struct({
    channel: effect_1.Schema.Literal('command'),
    command: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: 'Command name. Handled prefixes: `consumables.sync*`, `consumables.get*`, `dispenser.vendingconfiguration*`, `system.ping*`; anything else is logged and dropped.',
    }),
    fingerprint: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: 'Request fingerprint echoed to the device',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.Command`,
    title: 'Device command',
    description: 'The command body. Further command-specific fields are passed through to the handler.',
});
exports.Envelope = effect_1.Schema.Struct({
    deviceId: effect_1.Schema.optionalWith(Device.Class.Common.Id, { exact: true }).annotations({
        description: 'Target device; `serialNumber` is an alias. One of the two is required.',
    }),
    serialNumber: effect_1.Schema.optionalWith(Device.Class.Common.Id, { exact: true }).annotations({
        description: 'Alias of `deviceId`',
    }),
    body: exports.Command,
}).annotations({
    identifier: `${exports.NAMESPACE}.Envelope`,
    title: 'Device command envelope',
});
//# sourceMappingURL=schema.js.map